/**
 * Route for `custom-partner-email-sender-domain-smtp-relay-per`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomPartnerEmailSenderDomainSmtpRelayPerPage } from "../features/custom-partner-email-sender-domain-smtp-relay-per/CustomPartnerEmailSenderDomainSmtpRelayPerPage";

export const customPartnerEmailSenderDomainSmtpRelayPerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-partner-email-sender-domain-smtp-relay-per",
	component: CustomPartnerEmailSenderDomainSmtpRelayPerPage,
});

export default customPartnerEmailSenderDomainSmtpRelayPerRoute;
